function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgRiderIssues(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.3 56.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.437c6.639 0 12.031 5.393 12.031 12.032 0 6.638-5.392 12.03-12.031 12.03s-12.031-5.392-12.031-12.03c0-6.639 5.392-12.032 12.03-12.032zm13.75 34.375c5.683 0 10.312 4.63 10.312 10.313v3.437H3.437v-3.437c0-5.683 4.63-10.313 10.313-10.313 9.13 0 7.23 1.72 13.75 1.72 6.542 0 4.608-1.72 13.75-1.72zM27.5 0C18.96 0 12.03 6.929 12.03 15.469S18.96 30.937 27.5 30.937 42.969 24.01 42.969 15.47 36.04 0 27.499 0zm13.75 34.375c-9.926 0-7.627 1.719-13.75 1.719-6.102 0-3.835-1.72-13.75-1.72C6.155 34.375 0 40.53 0 48.125v3.438A3.434 3.434 0 003.437 55h48.125A3.434 3.434 0 0055 51.562v-3.437c0-7.595-6.155-13.75-13.75-13.75z",
    id: _id
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.65 .65)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#".concat(_id)
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#3C3C3B",
    strokeWidth: 1.3,
    fill: "#76DAE7",
    xlinkHref: "#".concat(_id)
  })));
}
export default SvgRiderIssues;